import { useFormState } from 'react-hook-form';
import { FormContainer } from 'react-hook-form-mui';
import { useTranslation } from 'react-i18next';

import { AlertError } from 'Common/AlertError';
import { PasswordField } from 'Common/Form';
import { ResetPasswordSchema } from 'Common/Form/ValidationSchemas/ResetPasswordSchema';
import { StyledAuthFormContainer, StyledButton } from 'Components/Styled';
import { useAppForm } from 'Utils/customHooks';

import type { IResetPasswordRequest } from '@/libs/models';

const formFieldNames = {
  hash: 'hash',
  password: 'password',
  confirmPassword: 'confirmPassword'
} as const;

type Props = {
  hash: string;
  onSubmit: (formData: IResetPasswordRequest) => void;
  error?: string | null;
};

export const ResetPasswordForm = ({ hash, onSubmit, error }: Readonly<Props>) => {
  const { t } = useTranslation();
  const formContext = useAppForm<IResetPasswordRequest>(ResetPasswordSchema());
  const { isValid } = useFormState({ control: formContext.control });

  return (
    <FormContainer onSuccess={onSubmit} formContext={formContext}>
      <StyledAuthFormContainer>
        {error && <AlertError text={t(error)} />}

        <input type="hidden" {...formContext.register(formFieldNames.hash)} value={hash} />

        <PasswordField
          name={formFieldNames.password}
          label={t('auth.password')}
          helperText={t('auth.passwordRequirements')}
        />

        <PasswordField name={formFieldNames.confirmPassword} label={t('auth.confirmPassword')} />

        <StyledButton type="submit" size="large" disabled={!isValid}>
          {t('auth.resetPassword')}
        </StyledButton>
      </StyledAuthFormContainer>
    </FormContainer>
  );
};
